import React from "react";
import useMediaView from "features/common/hooks/useMediaView";
import TagDetailWebPage from "./(web)/TagDetailWebPage";
import TagDetailMobilePage from "./(mobile)/TagDetailMobilePage";
import { useParams } from "react-router-dom";
import useTagsDetailQuery from "features/tag/hooks/queries/useTagsDetailQuery";

const TagDetailPage = () => {
  const isSmall = useMediaView("small");
  const { id } = useParams();

  if (!id) {
    throw new Error("id is required");
  }

  const { data } = useTagsDetailQuery(id);

  return (
    <>
      {!isSmall && <TagDetailWebPage data={data.data.result} id={id} />}
      {isSmall && <TagDetailMobilePage data={data.data.result} id={id} />}
    </>
  );
};

export default TagDetailPage;
